import { shape, number, string, oneOf } from 'prop-types';
import { MODES } from '../../../constants';

export const gigShape = shape({
    id: number,
    status: string,
    title: string,
    rating: number,
    ratingCount: number,
    price: number,
    thumbnail: string,
    url: string,
    categoryId: number,
    subCategoryId: number,
    seller: shape({
        username: string,
        profilePhoto: string,
    }),
});

export const widgetType = oneOf([MODES.RANDOM_GIGS, MODES.SPECIFIC_GIG]);
